import React from "react";
import PageHeader from "../../../app/layout/PageHeader";

export default function StaticDataManagementPage() {
  return (
    <div>
      <PageHeader
        title="Static data"
        subtitle="Manage the reference data used across FrontLine."
      />
      <div className="card">
        Static data management will be added here.
      </div>
    </div>
  );
}
